import Link from 'next/link'

export const CopyrightFooter = () => {
  return (
    <div className="flex flex-col items-center justify-between border-y border-grey-200 bg-grey-100 px-6 py-4 md:flex-row md:px-12 md:py-8 lg:px-30">
      <div className="mb-4 flex items-center justify-center md:mb-0">
        <Link className="mr-4 text-sm text-grey-700 underline md:mr-6" href={'/privacy-policy'}>
          Privacy Policy
        </Link>
        <Link className="text-sm text-grey-700 underline" href={'/terms-and-conditions'}>
          Terms & Conditions
        </Link>
      </div>
      <p className="text-sm text-grey-700">© 2024 Supagas. All rights reserved.</p>
    </div>
  )
}

export default CopyrightFooter
